export default __webpack_public_path__ + "static/media/ConfamJaraThumbnail.3626aea3.png";